// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_file_qa.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { QAFileVersion, QAHistory } from "../../datagateway/v1/proposal_file_qa_pb";
/**
 * @generated from message mono.projectdata.v1.SelectProposalFinalFileRequest
 */ export class SelectProposalFinalFileRequest extends Message {
    static fromBinary(bytes, options) {
        return new SelectProposalFinalFileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectProposalFinalFileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectProposalFinalFileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectProposalFinalFileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string replaces_version_id = 3;
   */ _define_property(this, "replacesVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectProposalFinalFileRequest, "runtime", proto3);
_define_property(SelectProposalFinalFileRequest, "typeName", "mono.projectdata.v1.SelectProposalFinalFileRequest");
_define_property(SelectProposalFinalFileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "replaces_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RunProposalFileQARequest
 */ export class RunProposalFileQARequest extends Message {
    static fromBinary(bytes, options) {
        return new RunProposalFileQARequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunProposalFileQARequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunProposalFileQARequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunProposalFileQARequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string file_id = 2;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunProposalFileQARequest, "runtime", proto3);
_define_property(RunProposalFileQARequest, "typeName", "mono.projectdata.v1.RunProposalFileQARequest");
_define_property(RunProposalFileQARequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalFileQARequest
 */ export class ListProposalFileQARequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalFileQARequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalFileQARequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalFileQARequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalFileQARequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string file_id = 2;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalFileQARequest, "runtime", proto3);
_define_property(ListProposalFileQARequest, "typeName", "mono.projectdata.v1.ListProposalFileQARequest");
_define_property(ListProposalFileQARequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SelectProposalFinalFileResponse
 */ export class SelectProposalFinalFileResponse extends Message {
    static fromBinary(bytes, options) {
        return new SelectProposalFinalFileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectProposalFinalFileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectProposalFinalFileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectProposalFinalFileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QAFileVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectProposalFinalFileResponse, "runtime", proto3);
_define_property(SelectProposalFinalFileResponse, "typeName", "mono.projectdata.v1.SelectProposalFinalFileResponse");
_define_property(SelectProposalFinalFileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: QAFileVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RunProposalFileQAResponse
 */ export class RunProposalFileQAResponse extends Message {
    static fromBinary(bytes, options) {
        return new RunProposalFileQAResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunProposalFileQAResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunProposalFileQAResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunProposalFileQAResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QAHistory history = 1;
   */ _define_property(this, "history", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunProposalFileQAResponse, "runtime", proto3);
_define_property(RunProposalFileQAResponse, "typeName", "mono.projectdata.v1.RunProposalFileQAResponse");
_define_property(RunProposalFileQAResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "history",
            kind: "message",
            T: QAHistory
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalFileQAResponse
 */ export class ListProposalFileQAResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalFileQAResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalFileQAResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalFileQAResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalFileQAResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QAHistory history = 1;
   */ _define_property(this, "history", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalFileQAResponse, "runtime", proto3);
_define_property(ListProposalFileQAResponse, "typeName", "mono.projectdata.v1.ListProposalFileQAResponse");
_define_property(ListProposalFileQAResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "history",
            kind: "message",
            T: QAHistory
        }
    ]));
